import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'enas44',
  Description:
    'Here&#39;s all the online content included with your <strong>English Language Complete Revision &amp; Practice</strong>',
  Credits:
    '<p><em>With thanks to Bryn Shortland for the proofreading.</em></p>\n' +
    '\n' +
    '<p><em>Assessment objective wording licensed under the Open Government Licence.&nbsp;</em><a href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/" target="_blank"><i>https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/</i></a></p>\n' +
    '\n' +
    '<p><em>Clipart from Corel&nbsp;&reg;</em></p>\n' +
    '\n' +
    '<p><em>This RevisionHub does not include any official AQA questions and is not endorsed by AQA.</em></p>\n' +
    '\n' +
    '<p><i>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025.&nbsp; All rights reserved.</i></p>\n',
};
